import { Button, FeatureTooltip, Flex, Header, Icon, Text } from '@driftt/dds'
import { faCircleQuestion } from '@driftt/dds.icons/light/faCircleQuestion'
import React from 'react'

import leadQualImg from 'images/ai-lead-qual-help.png'

const EducationPopover = ({
  show,
  onOpenChange,
}: {
  show: boolean
  onOpenChange: () => void
}) => {
  return (
    <FeatureTooltip.Root open={show} onOpenChange={onOpenChange}>
      <FeatureTooltip.Trigger>
        <Button css={{ background: '$purple2' }} variant="education">
          <Icon icon={faCircleQuestion}></Icon>
          How does it work?
        </Button>
      </FeatureTooltip.Trigger>
      <FeatureTooltip.Content orientation="vertical">
        <Flex
          direction="column"
          alignItems="center"
          justifyContent="center"
          gap={2}
        >
          <img src={leadQualImg} alt="Lead Qualification" />
          <Header variant="h3" css={{ color: '$indigo11' }}>
            The AI lead qualification node will ask qualifying questions for
            you!
          </Header>
          <Text>
            Fill in the rules that are important for qualification here, and
            whenever you use the AI lead qualification node in a playbook our AI
            chatbot will ask all the relevant questions to qualify them.
          </Text>
          <Text>
            You only have to configure this once for it to work on all
            playbooks!
          </Text>
        </Flex>
      </FeatureTooltip.Content>
    </FeatureTooltip.Root>
  )
}

export default EducationPopover
